import ReactMarkdown, { Components } from 'react-markdown';
import Typography from './Typography';
import Link from './Link';

const components: Components = {
  a: ({ children, href }) => <Link href={href!}>{children}</Link>,
  h1: ({ children }) => (
    <Typography component="h1" variant="h1">
      {children}
    </Typography>
  ),
  h2: ({ children }) => (
    <Typography component="h2" variant="h2">
      {children}
    </Typography>
  ),
  h3: ({ children }) => (
    <Typography component="h3" variant="h3">
      {children}
    </Typography>
  ),
  h4: ({ children }) => (
    <Typography component="h4" variant="h4">
      {children}
    </Typography>
  ),
  h5: ({ children }) => (
    <Typography component="h5" variant="h5">
      {children}
    </Typography>
  ),
  p: ({ children }) => <Typography variant="body">{children}</Typography>,
};

interface MarkdownProps {
  children: string;
}

/** Output markdown content */
function Markdown({ children }: MarkdownProps) {
  return <ReactMarkdown components={components}>{children}</ReactMarkdown>;
}

export default Markdown;
